import { HOME_ASSETS } from "@/home/home-assets";

export type HomeRailIconName = keyof typeof HOME_ASSETS.railIcons;

export function homeRailIcon(name: HomeRailIconName): string {
  const src = HOME_ASSETS.railIcons[name];
  return `<span class="home-rail-art" style="--rail-art: url('${src}')"></span>`;
}
